import { useUserContext } from 'common/contexts/UserContext';
import { Segment } from './segmentation';
import { Permission } from './permissions';

export const useIsDashboardUser = (): boolean => {
  const { user } = useUserContext();
  return (
    !!user &&
    user.company?.segmentation === Segment.Shipper &&
    user.company?.permissions?.includes(Permission.ShipmentWatchListDashboard)
  );
};
